import React from 'react'
import MedicinesFormAll from './components/MedicinesFormAll';

function Medicines() {
  return (
    <section className="hero is-fullheight-with-navbar">
      <div className="hero-body" style={{ alignItems: 'center' }}>
        <div className="container">
          <MedicinesFormAll />
        </div>
      </div>
    </section>
  )
}

export default Medicines;
